import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconFilterBarProps extends SVGProps<any> {}
export class SVGIconFilterBar extends Component<SVGIconFilterBarProps> {
  render() {
    const { width = 40, height = 40, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-filter-bar"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 ${width} ${height}`}
        {...rest}
      >
        <g clipPath="url(#clip0_1300_201)">
          <path
            d="M39.5117 37.1549L27.1551 24.7983L34.3967 17.3349C35.9017 15.7849 36.7301 13.7433 36.7301 11.5833C36.7301 7.03326 33.0284 3.3316 28.4784 3.3316H11.5851C9.96338 3.3316 8.40338 3.8266 7.06505 4.7066L2.84505 0.488262C2.19338 -0.163405 1.14005 -0.163405 0.488384 0.488262C-0.163283 1.13993 -0.163283 2.19326 0.488384 2.84493L37.1551 39.5116C37.48 39.8366 37.9067 39.9999 38.3334 39.9999C38.7601 39.9999 39.1867 39.8366 39.5117 39.5116C40.1634 38.8599 40.1634 37.8066 39.5117 37.1549ZM11.5851 6.66659H28.4801C31.1917 6.66659 33.3984 8.87326 33.3984 11.5849C33.3984 12.8716 32.9051 14.0899 32.0067 15.0149L24.8001 22.4416L9.50505 7.14826C10.1534 6.84493 10.8551 6.66659 11.5834 6.66659H11.5851ZM25.0001 31.6666V38.3333C25.0001 38.9649 24.6434 39.5416 24.0784 39.8249C23.8417 39.9433 23.5867 39.9999 23.3334 39.9999C22.9801 39.9999 22.6284 39.8866 22.3334 39.6666L15.6667 34.6666C15.2467 34.3533 15.0001 33.8583 15.0001 33.3333V26.9266L5.66838 17.3366C4.95838 16.6066 4.39505 15.7599 3.99505 14.8199C3.63505 13.9733 4.02838 12.9933 4.87505 12.6333C5.72172 12.2699 6.70005 12.6649 7.06172 13.5133C7.30005 14.0733 7.63505 14.5783 8.05838 15.0116L17.8617 25.0866C18.1651 25.3983 18.3334 25.8149 18.3334 26.2483V32.4983L21.6667 34.9983V31.6649C21.6667 30.7449 22.4134 29.9983 23.3334 29.9983C24.2534 29.9983 25.0001 30.7466 25.0001 31.6666Z"
            fill="#513389"
          />
        </g>
        <defs>
          <clipPath id="clip0_1300_201">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </SVG>
    );
  }
}
